import {UtilityActionTypes} from '../actions/actionTypes';
import {IUtilityState} from '../../Interfaces';
import * as actions from '../actions/actionTypes';

const initialState = {
  toggle: true,
};

export default (
  state = initialState,
  action: UtilityActionTypes,
): IUtilityState => {
  if (action.type === actions.TOGGLE_SIDEBAR) {
    return {...state, toggle: action.payload};
  }
  return state;
};
